<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <!-- Ícono + texto hardcodeados a propósito: esta vista no tiene fila
             en m_modules_permissions (no es un módulo, ver router.js), así
             que no hay de dónde leerlos como en el resto de los listados
             (ModuleViewHeading) — ver docs/tabs-layout y docs/list-view-interfaces. -->
        <section class="list-view-heading">
          <div class="changelog-heading__summary d-none d-md-flex">
            <span class="changelog-heading__icon"><AppIcon name="history" /></span>
            <p>{{ headingText }}</p>
          </div>
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 320px;">
              <label class="filter-label">Módulo</label>
              <b-form-select v-model="filter.module" size="sm" @change="applyFilters()">
                <b-form-select-option value="">Todos los módulos</b-form-select-option>
                <b-form-select-option
                  v-for="mod in modules"
                  :key="mod.key"
                  :value="mod.key">
                  {{ mod.name }}
                </b-form-select-option>
              </b-form-select>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filter.dateFrom" @change="applyFilters()"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filter.dateTo" @change="applyFilters()"></b-form-input>
            </div>
            <b-button variant="outline-secondary"
                      size="sm"
                      class="changelog-filter-clear"
                      @click="clearFilters()"
                      v-b-tooltip.hover
                      title="Limpiar filtros"
                      aria-label="Limpiar filtros">
              <AppIcon name="filter_alt_off" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="3">
          <b-card no-body>
            <button type="button"
                    class="changelog-summary-header"
                    :aria-expanded="!isMobileViewport || summaryOpen"
                    @click="toggleSummary()">
              <span><AppIcon name="widgets" class="mr-1" />Resumen por módulo</span>
              <AppIcon name="expand_more" class="changelog-summary-header__chevron" :class="{ 'changelog-summary-header__chevron--open': !isMobileViewport || summaryOpen }" />
            </button>
            <div class="changelog-summary-list" v-show="!isMobileViewport || summaryOpen">
              <button
                type="button"
                class="changelog-summary-item"
                :class="{ 'changelog-summary-item--active': filter.module === '' }"
                @click="filterByModule('')">
                <span>Todos los módulos</span>
                <b-badge variant="secondary" pill>{{ allChanges.length }}</b-badge>
              </button>
              <button
                v-for="mod in moduleSummary"
                :key="mod.key"
                type="button"
                class="changelog-summary-item"
                :class="{ 'changelog-summary-item--new': moduleHasRecent(mod.key), 'changelog-summary-item--active': filter.module === mod.key }"
                @click="filterByModule(mod.key)">
                <span>{{ mod.name }}</span>
                <b-badge variant="secondary" pill>{{ mod.count }}</b-badge>
              </button>
            </div>
          </b-card>

          <b-card class="mt-3" no-body>
            <div class="changelog-stats">
              <div class="changelog-stat">
                <span class="changelog-stat__value">{{ currentMonthChanges }}</span>
                <span class="changelog-stat__label">mes en curso</span>
              </div>
              <div class="changelog-stat">
                <span class="changelog-stat__value">{{ allChanges.length }}</span>
                <span class="changelog-stat__label">cambios totales</span>
              </div>
            </div>
          </b-card>
        </b-col>

        <b-col lg="9">
          <div v-if="groupedChanges.length">
            <section v-for="group in groupedChanges" :key="group.date" class="changelog-date-group">
              <h6 class="changelog-date-heading">
                <AppIcon name="calendar_month" class="mr-1" />
                {{ formatDate(group.date) }}
              </h6>

              <div class="changelog-list">
                <article
                  v-for="(item, index) in group.items"
                  :key="index"
                  class="changelog-item"
                  :class="{ 'changelog-item-new': isRecent(item) }">

                  <div class="changelog-item__body">
                    <p class="changelog-item__description">{{ item.description }}</p>
                    <div class="changelog-item__meta">
                      <span class="changelog-new" v-if="isRecent(item)">Nuevo</span>
                    </div>
                  </div>
                  <b-badge :variant="isGeneralChange(item) ? 'danger' : 'secondary'" pill class="changelog-item__module">
                    {{ item.module_name }}
                  </b-badge>
                </article>
              </div>
            </section>
          </div>

          <EmptyState v-else
                      icon="history"
                      title="No se encontraron cambios"
                      description="Ajustá los filtros para ampliar el historial visible." />

        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script>
  import Session from '@/handler/session'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'
  import changelogData from '@/components/changelog/data.json'
  import { EventBus } from '@/handler/event-bus'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {
        filtersOpen: false,
        isMobileViewport: false,
        summaryOpen: true,
        filter: {
          module: '',
          dateFrom: '',
          dateTo: ''
        },
        allChanges: [],
        filteredList: [],
        headingText: 'Mejoras y novedades de cada actualización del sistema',
      }
    },
    created() {
      // Título e ícono hardcodeados a propósito, ver comentario en el
      // template — esta vista no tiene fila en m_modules_permissions.
      this.announceTabMetadata()
    },
    // Con <keep-alive> (DefaultTabsLayout.vue), volver a esta vista ya
    // visitada dispara activated() en vez de created().
    activated() {
      this.announceTabMetadata()
    },
    computed: {
      modules() {
        var map = {}
        this.allChanges.forEach(item => {
          if (!map[item.module]) {
            map[item.module] = item.module_name
          }
        })

        var result = []
        for (var key in map) {
          result.push({ key: key, name: map[key] })
        }
        return result.sort((a, b) => a.name.localeCompare(b.name))
      },
      groupedChanges() {
        var groups = {}
        this.filteredList.forEach(item => {
          if (!groups[item.date]) {
            groups[item.date] = []
          }
          groups[item.date].push(item)
        })

        var result = []
        var dates = Object.keys(groups).sort((a, b) => b.localeCompare(a))
        dates.forEach(date => {
          result.push({ date: date, items: groups[date] })
        })
        return result
      },
      moduleSummary() {
        var map = {}
        this.allChanges.forEach(item => {
          if (!map[item.module]) {
            map[item.module] = { key: item.module, name: item.module_name, count: 0, lastDate: item.date }
          }
          map[item.module].count++
          if (item.date > map[item.module].lastDate) {
            map[item.module].lastDate = item.date
          }
        })

        var result = []
        for (var key in map) {
          result.push(map[key])
        }
        return result.sort((a, b) => {
          if (b.lastDate === a.lastDate) {
            return b.count - a.count
          }
          return b.lastDate.localeCompare(a.lastDate)
        })
      },
      currentMonthChanges() {
        var today = new Date()
        var year = today.getFullYear()
        var month = today.getMonth() + 1

        return this.allChanges.filter(item => {
          if (!item || !item.date) {
            return false
          }
          var parts = item.date.split('-')
          return parseInt(parts[0]) === year && parseInt(parts[1]) === month
        }).length
      }
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_changelog_staff') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.summaryOpen = !this.isMobileViewport
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadChangelog()
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_changelog_staff', value ? 'true' : 'false')
      },
    },
    methods: {
      announceTabMetadata() {
        EventBus.$emit('Update:TabMetadata', { title: 'Registro de Cambios', subtitle: this.headingText, icon: 'history' })
      },
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.summaryOpen = !e.matches
      },
      toggleSummary() {
        if(this.isMobileViewport) {
          this.summaryOpen = !this.summaryOpen
        }
      },
      getUserModules() {
        var modules = []
        if (Session.getSession().auth && Session.getSession().auth.user.permissions) {
          var menu = Session.getSession().auth.user.permissions.menu
          for (var prop in menu) {
            modules.push(menu[prop].router)
          }
        }
        return modules
      },
      loadChangelog() {
        var userModules = this.getUserModules()
        var data = changelogData.slice()

        if (userModules.length) {
          data = data.filter(item => item.module === 'general' || userModules.indexOf(item.module) !== -1)
        }

        this.allChanges = data.sort((a, b) => b.date.localeCompare(a.date))
        this.filteredList = this.allChanges.slice()

        // Si viene con query param de módulo, filtrar
        if (this.$route.query.module) {
          this.filter.module = this.$route.query.module
          this.applyFilters()
        }
      },
      applyFilters() {
        var data = this.allChanges.slice()

        if (this.filter.module) {
          data = data.filter(item => item.module === this.filter.module)
        }
        if (this.filter.dateFrom) {
          data = data.filter(item => item.date >= this.filter.dateFrom)
        }
        if (this.filter.dateTo) {
          data = data.filter(item => item.date <= this.filter.dateTo)
        }

        this.filteredList = data
      },
      clearFilters() {
        this.filter.module = ''
        this.filter.dateFrom = ''
        this.filter.dateTo = ''
        this.filteredList = this.allChanges.slice()
      },
      filterByModule(moduleKey) {
        this.filter.module = moduleKey
        this.applyFilters()
        if(this.isMobileViewport) {
          this.summaryOpen = false
        }
      },
      formatDate(dateStr) {
        var parts = dateStr.split('-')
        var months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
        var monthIndex = parseInt(parts[1]) - 1
        return parts[2] + ' de ' + months[monthIndex] + ', ' + parts[0]
      },
      isRecent(item) {
        var today = new Date()
        var thirtyDaysAgo = new Date(today.getTime() - (30 * 24 * 60 * 60 * 1000))
        var limitDate = thirtyDaysAgo.toISOString().substring(0, 10)
        return item && item.date >= limitDate
      },
      isGeneralChange(item) {
        return item && item.module === 'general'
      },
      moduleHasRecent(moduleKey) {
        return this.allChanges.some(item => item.module === moduleKey && this.isRecent(item))
      }
    }
  }
</script>

<style scoped>
  /* Mismos números que .module-view-heading--summary (ModuleViewHeading.vue)
     / .dashboard-page-heading__summary (SimpleModuleDashboard.vue), para que
     esta cabecera se lea igual que el resto — acá hardcodeados en vez de
     usar el componente porque no hay metadata en base para esta vista. */
  .changelog-heading__summary {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 36px;
  }
  .changelog-heading__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    font-size: 0.85rem;
  }
  .changelog-heading__summary p {
    margin: 0;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-medium);
  }
  .changelog-filter-clear {
    align-items: center;
    display: inline-flex;
    flex: 0 0 auto;
    height: 31px;
    justify-content: center;
    padding: 0;
    width: 31px;
  }
  .changelog-date-group {
    margin-bottom: 16px;
  }
  .changelog-date-heading {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: flex;
    font-size: var(--app-text-sm);
    font-weight: 700;
    margin-bottom: 8px;
  }
  .changelog-list {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    overflow: hidden;
  }
  .changelog-item {
    align-items: flex-start;
    background: var(--app-color-surface);
    border-left: 3px solid var(--app-color-primary);
    border-bottom: 1px solid var(--app-color-border);
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 12px;
  }
  .changelog-item:last-child {
    border-bottom: 0;
  }
  .changelog-item-new {
    background: var(--app-color-primary-soft);
    border-left-color: var(--app-color-primary);
  }
  .changelog-item__body {
    min-width: 0;
  }
  .changelog-item__description {
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    margin: 0;
  }
  .changelog-item__meta {
    margin-top: 4px;
  }
  .changelog-item__module {
    flex: 0 0 auto;
    white-space: nowrap;
  }
  .changelog-new {
    align-items: center;
    background: var(--app-color-surface);
    border: 1px solid var(--app-color-primary-200);
    border-radius: 999px;
    color: var(--app-color-primary);
    display: inline-flex;
    font-size: var(--app-text-xs);
    font-weight: 700;
    padding: 2px 7px;
    text-transform: uppercase;
  }
  .changelog-summary-header {
    align-items: center;
    background: var(--app-color-surface);
    border-bottom: 1px solid var(--app-color-border);
    border-left: 0;
    border-right: 0;
    border-top: 0;
    color: var(--app-color-text-secondary);
    display: flex;
    font-size: var(--app-text-xs);
    font-weight: 700;
    justify-content: space-between;
    padding: 10px 12px;
    text-align: left;
    text-transform: uppercase;
    width: 100%;
  }
  .changelog-summary-header__chevron {
    display: none;
    transition: transform 0.15s ease;
  }
  .changelog-summary-header__chevron--open {
    transform: rotate(180deg);
  }
  .changelog-summary-list {
    display: flex;
    flex-direction: column;
  }
  .changelog-summary-item {
    align-items: center;
    background: transparent;
    border: 0;
    border-bottom: 1px solid var(--app-color-border);
    color: var(--app-color-text-secondary);
    display: flex;
    font-size: var(--app-text-sm);
    justify-content: space-between;
    padding: 9px 12px;
    text-align: left;
    width: 100%;
  }
  .changelog-summary-item:last-child {
    border-bottom: 0;
  }
  .changelog-summary-item:hover,
  .changelog-summary-item:focus,
  .changelog-summary-item--active {
    background: var(--app-color-primary-soft);
    color: var(--app-color-primary);
    outline: none;
  }
  .changelog-summary-item--new:not(.changelog-summary-item--active) {
    background: var(--app-color-surface-subtle);
    box-shadow: inset 3px 0 0 var(--app-color-primary);
  }
  .changelog-stats {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .changelog-stat {
    padding: 14px 10px;
    text-align: center;
  }
  .changelog-stat + .changelog-stat {
    border-left: 1px solid var(--app-color-border);
  }
  .changelog-stat__value {
    color: var(--app-color-text);
    display: block;
    font-size: 24px;
    font-weight: 700;
    line-height: 1;
  }
  .changelog-stat__label {
    color: var(--app-color-text-muted);
    display: block;
    font-size: var(--app-text-xs);
    margin-top: 4px;
  }
  @media (max-width: 767.98px) {
    .changelog-summary-header__chevron {
      display: inline-flex;
    }
    .changelog-item {
      flex-direction: column;
      gap: 8px;
    }
    .changelog-item__module {
      align-self: flex-start;
    }
  }
</style>
